import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface AgentsLibraryModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const AgentsLibraryModal = ({
  open,
  onOpenChange,
}: AgentsLibraryModalProps) => {
  const navigate = useNavigate();

  const handleExploreNow = () => {
    onOpenChange(false);
    navigate("/stacey-library");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl p-0 overflow-hidden rounded-2xl">
        {/* Thumbnail Image */}
        <div className="w-full">
          <img
            src="/images/agents-library-announcement.png"
            alt="Agents Library Preview"
            className="w-full h-auto"
          />
        </div>

        {/* Content */}
        <div className="px-6 pb-6 pt-2">
          <DialogHeader className="space-y-1">
            <DialogTitle className="text-xl font-bold text-gray-900">
              Explore the agents library
            </DialogTitle>
            <DialogDescription className="text-base text-gray-600 leading-relaxed">
              Stacey now has specialized AI agents designed to help you at every
              stage of your consulting journey.
            </DialogDescription>
          </DialogHeader>

          <div className="mt-6">
            <Button
              onClick={handleExploreNow}
              className="w-full bg-sds-purple-100 hover:bg-sds-purple-80 text-white font-semibold py-3 rounded-lg"
            >
              Explore Now
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
